import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface ShareableLinkModel {
	readonly shareableLink: string;
}

export const useShareableLink = (collectionId: string, enabled: boolean) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["shareableLink", collectionId],
		enabled,
		queryFn: () => http<ShareableLinkModel>({
			method: "GET",
			url: `/collection/${collectionId}/public/shareable-link`
		})
	});
};
